export default class QueriesController {
  _api;
  _paths;
  constructor(requestService, paths) {
    this._api = requestService;
    this._paths = paths;
  }

  Command(execute) {
    return { execute };
  }

  getNotificationsQuery({ userId, userIsAParent }) {
    const api = this._api;
    const path = this._paths.NOTIFICATION_LIST_PATH(userId, userIsAParent);
    return this.Command(async function() {
      const {
        data: { notifications: _notifications, total },
      } = await api.Get(path);
      return {
        notifications: _notifications,
        total,
      };
    });
  }
}

